import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  content: {
    margin: `${theme.spacing(2)}px ${-theme.spacing(1)}px ${theme.spacing(3)}px`,
  },
  card: {
    backgroundColor: '#fff',
    border: '1px solid #ECEFF1',
    borderRadius: 8,
    padding: theme.spacing(2.5),
  },
  sectionTitle: {
    color: '#072D83',
    fontSize: 16,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1),
  },
  fieldTitle: {
    color: '#37474F',
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '150%',
    marginBottom: 5,
  },
  fieldValue: {
    color: '#78909C',
    fontSize: 14,
    lineHeight: '150%',
  },
  btnContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  bankData: {
    fontSize: 14,
    lineHeight: '150%',
    color: '#37474F',
  },
}));
